import { SchmancyElement } from '@schmancy/mixins/index'
import { css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

/** @csspart content - The inner wrapper; style to override panel backgrounds, shadows, padding, or borders without shadow-root piercing. */
@customElement('schmancy-dropdown-content')
export class SchmancyDropdownContent extends SchmancyElement {
	static styles = [
		css`
			:host {
				display: block;
				position: relative;
				min-width: 10rem;
				margin: 0;
				overflow: hidden;
				text-align: left;
				list-style: none;
				background-color: var(--schmancy-sys-color-surface-container);
				background-clip: padding-box;
				border-radius: var(--schmancy-radius-lg, 0.625rem);
				box-shadow: var(--schmancy-sys-elevation-3);
				will-change: transform;
				transform-origin: top left;
				animation: dropdownAnimation 0.1s ease-out forwards;
			}

			:host([hidden]) {
				display: none;
			}

			:host(:not([shadow])) {
				box-shadow: none;
			}

			:host([radius='full']) {
				border-radius: var(--schmancy-radius-full, calc(infinity * 1px));
			}

			@keyframes dropdownAnimation {
				from {
					opacity: 0;
					transform: scale(0.95);
				}
				to {
					opacity: 1;
					transform: scale(1);
				}
			}
		`,
	]
	@property({ type: String })
	width: string = 'auto'

	@property({ type: String })
	maxHeight: string = '80vh'

	/** Reflected: `:host(:not([shadow]))` drops the elevation. */
	@property({ type: Boolean, reflect: true })
	shadow: boolean = true

	/** Reflected: `:host([radius='full'])` selects the corner. */
	@property({ type: String, reflect: true })
	radius: 'lg' | 'full' = 'lg'

	render() {
		const styles = {
			width: this.width,
			maxHeight: this.maxHeight,
		}

		return html`
			<div class="overflow-auto" style=${this.styleMap(styles)} part="content">
				<slot></slot>
			</div>
		`
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-dropdown-content': SchmancyDropdownContent
	}
}
